/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react';
import { useStaticQuery } from 'gatsby';
import GlobalStyle from '@components/global-style';
import Header from '@components/header';
import Footer from '@components/footer';
import Wrapper from '@components/wrapper.styled';
import { Container, Content } from './default-layout.styled';
import './fonts.css';
var defaultStylesProps = {
    muted: '#888888',
    black: '#000000',
    white: '#ffffff',
    dark: '#212121',
    primary: '#00ffb0',
    gray: '#707070',
    color_block_border_radius: {
        text: '0'
    },
    button_border_radius: {
        text: '0.13rem'
    }
};
var Layout = function Layout(_ref) {
    var children = _ref.children;
    var _useStaticQuery = useStaticQuery("2111873472"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(GlobalStyle, {
        stylesProps: (prismicStylesConfig === null || prismicStylesConfig === void 0 ? void 0 : prismicStylesConfig.data) || defaultStylesProps
    }), /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement(Content, null, /*#__PURE__*/ React.createElement(Wrapper, null, children)), /*#__PURE__*/ React.createElement(Footer, null));
};
export default Layout;
